import { Component, OnInit, Input } from '@angular/core';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';
import { UscModalComponent } from '../usc-modal/usc-modal.component';
import { UscEmailComposerComponent } from '../usc-email-composer/usc-email-composer.component';
import { UscAttachmentLookupComponent } from '../usc-attachment-lookup/usc-attachment-lookup.component';
import { UscTimeslotPickerComponent } from '../usc-timeslot-picker/usc-timeslot-picker.component';
import { User } from '../../../models';
import { AuthService } from '../../../services';

@Component({
    selector: 'sn-usc-chat-details',
    templateUrl: './usc-chat-details.component.html',
    styleUrls: ['../usc-store.component.css', './usc-chat-details.component.css']
})
export class UscChatDetailsComponent implements OnInit {
    @Input() item: any;
    // @Input() adapter:UscChatAdapter;

    public activeUser: User;
    public isLeader: boolean = false;
    public isUSCellAgent: boolean = false;
    public isUSCellTelesales: boolean = false;
    public isFirstImpression: boolean = false;
    public isMiddleImpression: boolean = false;
    public isLastingImpression: boolean = false;
    public isOutcomeAllowed: boolean = false;
    public isLoading: boolean = false;
    // views
    public view: string = "";
    public view_first: string = this.uscStoreService.form_first_impression;
    public view_middle: string = this.uscStoreService.form_middle_impression;
    public view_lasting: string = this.uscStoreService.form_lasting_impression;
    // actions
    public action_no_answer: string = this.uscStoreService.action_no_answer;
    public action_no_show_archive: string = this.uscStoreService.action_no_show_archive;
    public action_move_to_first: string = this.uscStoreService.action_move_to_first;
    public action_mass_archive: string = this.uscStoreService.action_mass_archive;
    public action_mass_reassign: string = this.uscStoreService.action_mass_reassign;
    public action_auto_reassign: string = this.uscStoreService.action_auto_reassign;
    // transition
    public transition_no_show: string = "transition_no_show";
    public transition_optin_request: string = "transition_optin_request";
    public transition_compose_email: string = "transition_compose_email";
    public transition_mass_reassign: string = "transition_mass_reassign";
    public transition_new_referral: string = "transition_new_referral";
    public event_save_call_back:string = "save_call_back";

    public view_interested: string = this.uscStoreService.form_interested;
    public view_not_interested: string = this.uscStoreService.form_not_interested;
    public view_call_back: string = this.uscStoreService.form_call_back;

    public view_purchase: string = this.uscStoreService.form_purchase;
    public view_future_sales: string = this.uscStoreService.form_future_sale;
    public view_no_purchase: string = this.uscStoreService.form_no_purchase;
    public view_reschedule: string = this.uscStoreService.form_reschedule;
    public view_file_upload: string = this.uscStoreService.form_file_upload;

    public isUSCellRetail:boolean = false;

    constructor(
        public uscStoreService: UscStoreService,
        public ngbModal: NgbModal,
        public ngbActiveModal: NgbActiveModal,
        public authService: AuthService,
    ) { }

    ngOnInit() {
        this.activeUser = this.authService.getActive();
        this.isLeader = this.uscStoreService.isLeader();
        this.isUSCellRetail = this.uscStoreService.isUSCellRetail();
        this.isUSCellAgent = this.uscStoreService.isUSCellAgent();
        this.isUSCellTelesales = this.uscStoreService.isUSCellTelesales();
        this.setViewByItem(this.item);
        // console.log("UscChatDetailsComponent");
        // console.log(this.item);
    }

    setViewByItem(item) {
        this.isFirstImpression = false;
        this.isMiddleImpression = false;
        this.isLastingImpression = false;
        this.isOutcomeAllowed = item.dl_status == "AC" && item.dl_stage != "Archive";
        switch (item.dl_type) {
            case "First Impression":
                this.view = this.uscStoreService.view_first;
                this.isFirstImpression = true;
                this.view_interested = this.uscStoreService.form_interested;
                this.view_not_interested = this.uscStoreService.form_not_interested;
                this.view_call_back = this.uscStoreService.form_call_back;
                break;
            case "Middle Impression":
                this.view = this.uscStoreService.view_middle;
                this.isMiddleImpression = true;
                break;
            case "Lasting Impression":
                this.view = this.uscStoreService.view_lasting;
                this.isLastingImpression = true;
                this.view_interested = this.uscStoreService.form_last_interested;
                this.view_not_interested = this.uscStoreService.form_last_not_interested;
                this.view_call_back = this.uscStoreService.form_last_call_back;
                break;
        }
    }

    processOutcome(item, outcome) {
        switch (outcome) {
            case this.transition_no_show: this.showPromptDlg(item, outcome); break;
            case this.uscStoreService.action_no_answer:
            case this.uscStoreService.action_no_show_archive:
            case this.uscStoreService.action_move_to_first:
            case this.uscStoreService.action_move_to_lasting:
                var msg = "";
                if (outcome == this.uscStoreService.action_no_answer) msg = "Updating Lead";
                else if (outcome == this.uscStoreService.action_no_show_archive) msg = "Archiving Lead";
                else if (outcome == this.uscStoreService.action_move_to_first) msg = "Moving to First";
                else if (outcome == this.uscStoreService.action_move_to_lasting) msg = "Moving to Lasting";
                let dlg = this.showCustomPromptDlg(item, { msg: msg });
                this.uscStoreService.processActionOnViewItem(this.view, item.view_ID, outcome, "").subscribe(
                    result => {
                        dlg.close();
                        if (this.isSmsIntroductionEnabled(item) && outcome == this.uscStoreService.action_no_answer) {
                            item.cfd_lcod = (new Date()).toISOString();
                            this.showPromptDlg(item, this.transition_optin_request, outcome);
                        } else {
                            this.reloadUpdatedItem(item);
                        }
                    }
                );
                break;
            default:
                this.showOutcomeLog(item, outcome);
                break;
        }
    }

    reloadUpdatedItem(item) {
        if (item) {
            var dl_ID = item.new_dl_ID ? item.new_dl_ID : item.dl_ID;
            var idList = [dl_ID];
            var params: any = {
                idList: idList,
                p: 1,
                ps: idList.length,
                ob: "dl_ID",
                text: '',
                obd: "asc",
                est: "ST_Search",
            }

            // console.log("loadChatRelatedDeals");
            // console.log(params);
            this.isLoading = true;
            this.uscStoreService.reloadItem(item).subscribe(result => {
                //this.uscStoreService.getData(this.uscStoreService.view_search, params).subscribe(result => {
                if (result && result.items && result.items.length != 0) {
                    if (this.item.dl_ID != result.items[0].dl_ID) {
                        // keep a reference to the originating middle impression so the chat_adapter can update the chat related info
                        result.items[0].from_dl_ID = this.item.dl_ID;
                    }
                    this.item = result.items[0];  // update to the new changes to refresh the details
                    this.setViewByItem(this.item);
                    this.uscStoreService.setViewItemUpdated(this.item);
                } else {
                    console.log("reloadUpdatedItem: this log should not be printed");
                }
                this.isLoading = false;
            },
                err => {
                    console.log("Error: reloadUpdatedItem failed, retying...");
                    setTimeout(() => { this.reloadUpdatedItem(item); });
                }
            );

            if (this.uscStoreService.isItemInCurrentView(item)) {
                this.uscStoreService.setCurrentView(this.view);
            }
        }
    }

    showCustomPromptDlg(item, msg_config): NgbModalRef {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.view;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
        modalRef.componentInstance.msg_config = msg_config;
        return modalRef;
    }

    showOutcomeLog(item, outcome) {
        const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.view = outcome;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.openCustomInputEvent = this.openCustomInputDialog;
        // modalRef.result.then((result) => {
        //   //console.log(result);
        //   var bContainEmail = false;
        //   for (var i = 0; i < result.data.length; i++) {
        //     if (result.data[i].key == "co_email") {
        //       bContainEmail = result.data[i].value != null && result.data[i].value.indexOf('@') > 0;
        //     } else if (result.data[i].key == "dl_ID") {
        //       if (item.dl_ID != result.data[i].value) {
        //         // middle impression was WON so a new lasting impression got created (dl_ID changed)
        //         item.new_dl_ID = result.data[i].value;   
        //         if (result.archived == true) {
        //           item.dl_stage = "Archive";  // lasting impression may got Archive 
        //         }
        //       }
        //     }
        //   }
        //   if (outcome == this.view_purchase) {
        //     this.showOutcomeLog(item, this.uscStoreService.form_future_sale);
        //   } else if (outcome == this.view_future_sales) {
        //     this.showPromptDlg(item, this.transition_new_referral);
        //   } else if ((outcome == this.uscStoreService.form_interested || outcome == this.uscStoreService.form_last_interested) && bContainEmail) {
        //     this.showPromptDlg(item, this.transition_compose_email);
        //   } else {
        //     this.reloadUpdatedItem(item);
        //   }
        // }, (reason) => {
        //   console.log(outcome + ' Closed');
        // });

        modalRef.result.then((result) => {
            var bContainEmail = false;
            if (this.isSmsIntroductionEnabled(item) && outcome == this.uscStoreService.form_interested) {
                this.uscStoreService.setTriggerChatItemReload();                          // trigger chat reload in case the deal sms status changed
            }
            for (var i = 0; i < result.data.length; i++) {
                if (result.data[i].key == "co_email") {
                    bContainEmail = result.data[i].value != null && result.data[i].value.indexOf('@') > 0;
                }
            }

            var bPromptComposeEmail = false;
            var bPromptSmsCampaignIntro = false;
            var bPromptSameDayAlert = false;
            switch (outcome) {
                case this.uscStoreService.form_interested:
                case this.uscStoreService.form_last_interested:
                    bPromptComposeEmail = true;
                    if (!this.isUSCellTelesales) {
                        var cfd_fumd = result.data.find(d => d.key == 'cfd_fumd');
                        if (cfd_fumd) {
                            var date = new Date(cfd_fumd.value); // this will convert date value to localtime 
                            var today = new Date();
                            // compare UTC string to today instead due to javascript converts to localtime 
                            if (date.getUTCFullYear() == today.getFullYear() && date.getUTCMonth() == today.getUTCMonth() && date.getUTCDate() == today.getDate()) {
                                bPromptSameDayAlert = true;
                            }
                        }
                    }
                    break;
                case this.uscStoreService.form_call_back:
                case this.uscStoreService.form_lvm_no_answer:
                    bPromptSmsCampaignIntro = (this.isSmsIntroductionEnabled(item));
                    break;
            }
            if (bPromptSameDayAlert) {
                this.openOkDialog('Please alert other Associates within your store that you have booked a same-day appointment.', item, true);
            } else if (bPromptSmsCampaignIntro) {
                item.cfd_lcod = (new Date()).toISOString();
                this.showPromptDlg(item, this.transition_optin_request, result.event);
            } else if (bContainEmail && bPromptComposeEmail) {
                this.showPromptDlg(item, this.transition_compose_email, result.event);
            } else if (outcome == this.uscStoreService.form_not_interested && result.event == "save_to_lasting") {
                this.showOutcomeLog(item, this.uscStoreService.form_future_sale);
            } else if (outcome == this.uscStoreService.form_future_sale) {
                this.showPromptDlg(item, this.transition_new_referral);
            } else if (outcome == this.view_purchase) {
                this.showOutcomeLog(item, this.uscStoreService.form_future_sale);
            } else {
                this.reloadUpdatedItem(item);
            }
        }, (reason) => {
        });
    }

    isSmsIntroductionEnabled(item): boolean {
        if (item.co_type.indexOf('Existing') >= 0 && item.cfd_esi == "Yes" && this.uscStoreService.isCustomerTextMessagingEnabled()) {
            if (!this.showAssociate() || item.dl_account_type) {
                return (item.cfd_css == null || item.cfd_css == '' || item.cfd_css == 'None');
            }
        }
        return false;
    }

    showAssociate(): boolean {
        if (this.isUSCellAgent) {
            switch (this.activeUser.title) {
                case "Agent Development Mgr":
                case "Associate":
                case "Manager":
                case "Area Manager":
                case "Admin/Manager of Agency":
                case "Master":
                    return false;
                default:
                    return true;
            }
        }
        return false;
        // return this.isUSCellAgent && (title.indexOf('Store') >= 0 || title.indexOf('Admin/Manager of Agency') >= 0 || title.indexOf('Master') >= 0);
    }


    showPromptDlg(item, prompt, curr_event = "") {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.view;
        modalRef.componentInstance.data = item;
        switch (prompt) {
            case this.transition_no_show:
                modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_no_show;
                break;
            case this.transition_compose_email:
                modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_compose_email;
                break;
            case this.transition_new_referral:
                modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_new_referral;
                break;
            case this.transition_optin_request:
                modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_optin_request;
                break;
        }

        modalRef.result.then((result) => {
            switch (result.response) {
                case this.uscStoreService.response_record_purchase:
                    this.showOutcomeLog(item, this.uscStoreService.form_purchase);
                    break;
                case this.uscStoreService.response_move_to_first:
                    this.processOutcome(item, this.uscStoreService.action_move_to_first);
                    break;
                case this.uscStoreService.response_move_to_lasting:
                    this.processOutcome(item, this.uscStoreService.action_move_to_lasting);
                    break;
                case this.uscStoreService.response_archive:
                    this.processOutcome(item, this.uscStoreService.action_no_show_archive);
                    break;
                case this.uscStoreService.response_compose_email:
                    this.showEmailComposer(item);
                    break;
                case this.uscStoreService.response_new_referral:
                    this.createNewReferralLead(item);
                    break;
                case this.uscStoreService.response_optin_request_en:
                case this.uscStoreService.response_optin_request_fr:
                case this.uscStoreService.response_optin_request_es:
                    item.oi_status = 'RI';
                    if (item.cfd_esi == "Yes") item.cfd_css = 'Opt-In Requested';
                    var pref;
                    switch (result.response) {
                        case this.uscStoreService.response_optin_request_fr: pref = 'French'; break;
                        case this.uscStoreService.response_optin_request_es: pref = 'Spanish'; break;
                        default: pref = 'English'; break;
                    }
                    var params = { "cfd_lp": pref };
                    var sub = this.uscStoreService.processActionOnViewItem(this.view, item.view_ID, this.uscStoreService.action_send_optin_request, params).subscribe(result2 => {
                        item.oi_status = 'RI';
                        if (item.cfd_esi == "Yes") {
                            item.cfd_css = 'Opt-In Requested';
                            if (this.uscStoreService.isSmsIntroLimitEnabled(item.cfd_esil)) this.uscStoreService.incrementDailyCampaignIntroSMSCount(item.cm_ID);
                        }
                        if (curr_event == this.event_save_call_back) this.reloadUpdatedItem(item);
                        this.uscStoreService.setTriggerChatItemReload();
                    },
                        error => console.log(error)
                    );
                    break;
            }
        }, (reason) => {
            console.log(prompt + ' Closed');
            if (prompt == this.transition_new_referral) {
                this.showPromptDlg(item, this.transition_compose_email);
            } else if (reason != 'cancel') {
                this.reloadUpdatedItem(item);
            }
            // if (reason != 'cancel') this.reloadItems();
        });
    }

    showEmailComposer(item) {
        const modalRef = this.ngbModal.open(UscEmailComposerComponent, { size: "lg", backdrop: 'static', keyboard: false });
        modalRef.componentInstance.view = this.view;
        modalRef.componentInstance.item = item;
        modalRef.result.then((result) => {
            this.reloadUpdatedItem(item);
        }, (reason) => {
            console.log("Email Composer Closed");
            this.reloadUpdatedItem(item);
        });
    }

    createNewReferralLead(referral_item) {
        const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.view = this.uscStoreService.form_first_impression;   // default to first impression on new referral
        var referred_by = "Referred By: _FN_ _LN_".replace("_FN_", referral_item.co_firstname).replace("_LN_", referral_item.co_lastname);
        let new_lead = { dl_ID: 0, co_work_phone1: null, co_firstname: null, co_lastname: null, dl_account_type: referral_item.dl_account_type, dl_notes: referred_by };
        modalRef.componentInstance.data = new_lead;
        modalRef.result.then((result) => {
            console.log(result);
            let item: any = {};
            result.data.forEach(f => {
                if (f["key"] == "dl_type") {
                    item.dl_type = f["value"];
                } else if (f["key"] == "dl_ID") {
                    item.dl_ID = f["value"];
                    item.view_ID = item.dl_ID;
                }
            });

            switch (result.event) {
                case "save_to_first":
                case "save_to_middle":
                    this.uscStoreService.setGotoItem(item);
                    break;
                case "save_and_new":
                    this.createNewReferralLead(referral_item);
                    break;
                case "save_purchase":
                    this.showOutcomeLog(item, this.uscStoreService.form_future_sale);
                    break;
            }
        }, (reason) => {
            console.log("New Referral Closed");
        });
    }

    showAttachments(item) {
        const modalRef = this.ngbModal.open(UscAttachmentLookupComponent, { size: "lg", backdrop: 'static', keyboard: false });
        modalRef.componentInstance.view = this.view;
        modalRef.componentInstance.related_type = "contact";
        modalRef.componentInstance.related_ID = item.co_ID;
        modalRef.componentInstance.data = item;
        modalRef.result.then((result) => {
            console.log(result);
        }, (reason) => {
            console.log('Attachment Closed');
        });
    }

    formatContactNumber(phone: string) {
        var formatted = "";
        if (phone && phone.length == 10) {
            formatted = phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
        }
        return formatted;
    }

    showReferralIcon(item) {
        if (item.cm_name == "Referral" && item.dl_sub_type == "1st Attempt") {
            return true;
        }
        return false;
    }

    public openCustomInputDialog(formValues, field) {
        if (field.key == "cfd_fumts2" || field.key == "cfd_fumts") {
            var modal = this.ngbModal.open(UscTimeslotPickerComponent, { size: "lg", backdrop: 'static', keyboard: false });
            modal.componentInstance.schedule_date = new Date(formValues.cfd_fumd);
            modal.componentInstance.view_ID = formValues.dl_ID;
            // if (this.uscStoreService.isQueuingModuleAccessEnabled()) modal.componentInstance.scheduling_mode = "sn";
            return modal;
        }
        return null;
    }

    // helper methods - begin
    public openOkDialog(message, item, bReloadItem) {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_ok_prompt;
        modalRef.componentInstance.msg_config = { msg: message };
        modalRef.result.then((result) => {
            if (bReloadItem) this.reloadUpdatedItem(item);
        }, (reason) => {
        });
    }
    // helper methods - end
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-chat-details/usc-chat-details.component.ts